
















import { Prop } from 'vue-property-decorator';
import Component, { mixins } from 'vue-class-component';

import AnimatedHours from '../atoms/animated-hours.vue';
import TooltipAble from '../../mixins/tooltip';
import { SubBrand } from '@/store/modules/themes';
import { Modules } from '@/store/store';
import { namespace } from 'vuex-class';

export type DurationMinutes = number;
const themeModule = namespace(Modules.themes);

@Component({
  name: 'eq-web-charging-option',
  components: { AnimatedHours },
})
export default class ChargingOption extends mixins(TooltipAble) {
  @themeModule.Getter('subBrand')
  private readonly subBrand!: SubBrand;

  @Prop()
  public readonly description!: string;

  @Prop()
  public readonly chargingTime!: DurationMinutes;

  @Prop()
  public readonly unit!: string;

  private get chargingTimeMaxRestriction() {
    return this.chargingTime <= 24 * 60 ? this.chargingTime : 24 * 60 + 1;
  }

  private get isChargingTimeLongerThan24Hours() {
    return this.chargingTime > 24 * 60;
  }
}
